import { render } from "./pestel_main.vue?vue&type=template&id=34060a35&scoped=true"
import script from "./pestel_main.vue?vue&type=script&lang=js"
export * from "./pestel_main.vue?vue&type=script&lang=js"

import "./pestel_main.vue?vue&type=style&index=0&id=34060a35&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34060a35"]])

export default __exports__